import React, { Fragment, useEffect, useState } from "react"
import Backbar from "~/pages/NetworkProviders/BackBar";
import { v4 as uuidv4 } from 'uuid';

import Loader  from "~/components/loader"

import Security from "~/services/security";
import Survey   from "~/services/surveys";

const Yuno = ({})=> {

  const publisherId    = '3620206e-7902-4545-b445-27ba1613c4de';
  const conversionRate = '2500';
  const clickId        = uuidv4();
  const currentUser    = Security.currentUserValue;

  const [isLoading , setIsLoading] = useState(true);
  const [country   , setCountry]   = useState("");

  useEffect(()=> {
    (async ()=> {
      document.body.style.overflow = "hidden";
      setCountry((await Survey.yunoInfo()).country);
      setIsLoading(false);
    })();
  }, []);

  return (
    <Fragment>
      <Backbar path="/surveys" showLogo={true} />
      { isLoading ? <Loader type={19} center style={{marginTop: 150}} /> :
        <iframe
          width="100%"
          frameBorder="0"
          style={{height: "100vh"}}
          src={`https://offerwall.yunosurveys.com/offerwall/publisher_offers?device_id=${currentUser.id}&transaction_id=${clickId}&currency_name=Points&conversion_rate=${conversionRate}&country_code=${country}&publisher_user_uuid=${publisherId}`}
        ></iframe> }
    </Fragment>
  );
};

export default Yuno;
